import { FC, useEffect, useRef, useState } from "react";
import { 
  DateWrapper, 
  Employee, 
  EmployeeActionsPopup, 
  EmployeeActionsPopupElement, 
  EmployeeAvatar, 
  EmployeeBody, 
  EmployeeDeleteButtons, 
  EmployeeDeleteHead, 
  EmployeeDeleteTitle, 
  EmployeeDeleteWrapper, 
  EmployeeEditWrapper, 
  EmployeeEmail, 
  EmployeeInfoRow, 
  EmployeeName, 
  EmployeeNotFoundWrapper, 
  EmployeeRoleTag, 
  EmployeesHeadRow, 
  EmployeesHeadWrapper, 
  EmployeesMobileTable, 
  MoreIconWrapper
} from "./style";
import { EmpoyeeRow, useEmployees } from "../lib/useEmployees";
import { SortSelect } from "shared/ui/sortSelect";
import { AddLarge, CloseIcon } from "shared/ui/icons";
import { useBreadcrumbsStore } from "entities/breadcrumbs";
import { useGlobalStore } from "entities/global";
import Input from '@atomaro/ui-kit/components/Input/Input';
import Button from '@atomaro/ui-kit/components/Button/Button/Button';
import { SearchIcon } from "shared/ui/icons/searchIcon";
import { EmployeeAdd } from "./EmployeeAdd";
import DataTable, { TableColumn } from "react-data-table-component";
import { Profile } from "shared/ui/icons/hudIcons/profile";
import { toRem } from "shared/helpers";
import { useResize } from "app/lib/hooks/useResize";
import Popover from '@atomaro/ui-kit/components/Popover/Popover';
import { COLORS } from "shared/consts";

import Modal from '@atomaro/ui-kit/components/Modal/Modal';
import { Spacer } from "shared/ui/spacer";

type EmployeesTableAvatarProps = {
  src: string;
}
const EmployeesTableAvatar: FC<EmployeesTableAvatarProps> = ({
  src
}) => {
  return <Profile imgSrc={src} />
}

type EmployeesTableRoleProps = {
  role: string;
}
const EmployeesTableRole: FC<EmployeesTableRoleProps> = ({
  role
}) => {
  return <EmployeeRoleTag>{role}</EmployeeRoleTag>
}

type EmployeesEditCeilProps = {
  onDeleteClick: () => void;
}
const EmployeesEditCeil: FC<EmployeesEditCeilProps> = ({
  onDeleteClick
}) => {
  const [isOpened, setIsOpened] = useState<boolean>(false)
  return (
    <Popover
      isOpened={isOpened}
      onOpen={() => {setIsOpened(true)}}
      onClose={() => {setIsOpened(false)}}
      placement="bottomLeft"
      className="settingsPopupTable"
      innerChildren={
        <EmployeeActionsPopup>
          <EmployeeActionsPopupElement onClick={() => {setIsOpened(false); onDeleteClick()}}>
            Удалить
          </EmployeeActionsPopupElement>
        </EmployeeActionsPopup>
      }
    >
      <MoreIconWrapper onClick={() => {if (isOpened) setIsOpened(false)}}>
        <Button 
          variant="ghost"
          size="m"
          colorScheme="neutral"
          iconPrefix={
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="24.000000" height="24.000000" fill="none">
              <path id="Union" d="M13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8ZM13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z" fill={COLORS.NEUTRAL.DEFAULT} fillRule="evenodd" />
            </svg>
          }
        />
      </MoreIconWrapper>
    </Popover>
  )
}

export const Employees: FC = () => {
  const setCrumbs = useBreadcrumbsStore((s) => s.setCrumbs);
  const setPlusButtonCallback = useGlobalStore(s => s.setPlusButtonCallback);
  const { isScreenLg, isScreenMd } = useResize();

  const {
    sortItems,
    isNewEmployeeOpen,
    rows,
    userInfo,
    customStyles,
    searchString,
    isDeleteEmployeeOpen,
    setIsNewEmployeeOpen,
    setSearchString,
    onDeleteClick,
    onDeleteClose,
    onDeleteConfirm,
  } = useEmployees()

  const columns = useRef<TableColumn<EmpoyeeRow>[]>([
    {
      name: '',
      selector: (row) => row.avatar,
      cell: (row) => <EmployeesTableAvatar src={row.avatar} />,
      width: toRem(40),
    },
    {
      name: 'ФИО',
      selector: (row) => row.fio,
    },
    {
      name: 'Email',
      selector: (row) => row.email,
    },
    {
      name: 'Телефон',
      selector: (row) => row.phone,
    },
    {
      name: 'Дата рождения',
      selector: (row) => row.birthDate,
    },
    {
      name: 'Права',
      selector: (row) => row.role,
      cell: (row) => <EmployeesTableRole role={row.role} />,
    },
    {
      name: '',
      cell: (row) => (row.userId !== userInfo?.id && <EmployeesEditCeil onDeleteClick={() => onDeleteClick(row.userId)} />),
      width: toRem(40),
      compact: true,
    },
  ])


  useEffect(() => {
    setCrumbs([
      { title: "Моя пасека", url: "/", route: { path: "/" } },
      { title: "Журнал пчеловода", url: "/diary", route: { path: "/diary" } },
    ]);

    setPlusButtonCallback(() => setIsNewEmployeeOpen(true));

    return () => {
        setPlusButtonCallback(null)
    }
  }, []);
  return (
    <>
      <EmployeesHeadWrapper>
        <EmployeesHeadRow>
          <DateWrapper>
            <Input 
              placeholder="Поиск по ФИО"
              iconPrefix={<SearchIcon />}
              size={isScreenMd ? "m" : 's'}
              value={searchString}
              onChange={(evt) => setSearchString(evt.target.value)}
            />
          </DateWrapper>
          <SortSelect 
            items={sortItems.current}
            defaultValue="fio"
            onChange={console.log}
            isMobile={!isScreenMd}
          /> 
          {isScreenLg && 
          <Button 
            label="Добавить сотрудника"
            iconPrefix={<AddLarge />}
            style={{marginLeft: 'auto'}}
            onClick={() => setIsNewEmployeeOpen(true)}
          />
          }
        </EmployeesHeadRow>
      </EmployeesHeadWrapper>
      {rows.length == 0 && <EmployeeNotFoundWrapper>Сотрудники не найдены</EmployeeNotFoundWrapper>}
      {isScreenLg && rows.length > 0 ? 
      <DataTable
        columns={columns.current}
        data={rows}
        customStyles={customStyles}
      /> : 
      <EmployeesMobileTable>
        {rows.map(row => (
          <Employee $isMain>
            <EmployeeAvatar>
              <img src={row.avatar} alt="Image" />
            </EmployeeAvatar>
            <EmployeeBody>
              <EmployeeName>{row.fio}</EmployeeName>
              {row.email && <EmployeeEmail>{row.email}</EmployeeEmail>}
              <EmployeeInfoRow>
                <span>тел.</span>
                <p>{row.phone}</p>
              </EmployeeInfoRow>
              {row.birthDate && 
              <EmployeeInfoRow>
                <span>дата рождения</span>
                <p>{row.birthDate}</p>
              </EmployeeInfoRow>
              }
              <EmployeeRoleTag className="tag">{row.role}</EmployeeRoleTag>
            </EmployeeBody>

            {row.userId !== userInfo?.id && 
            <EmployeeEditWrapper>
              <EmployeesEditCeil onDeleteClick={() => onDeleteClick(row.userId)} />  
            </EmployeeEditWrapper>
            }
          </Employee>
        ))}
      </EmployeesMobileTable>
      }
      <EmployeeAdd 
        isOpen={isNewEmployeeOpen}
        onClose={() => setIsNewEmployeeOpen(false)}
        isMobile={!isScreenMd}
      />
      <Modal
        centered
        isOpen={isDeleteEmployeeOpen}
        onClickOverlay={onDeleteClose}
        style={{padding: 0}}
        maxWidth={isScreenMd ? 'auto' : `calc(100vw - ${toRem(32)})`}
      >
        <EmployeeDeleteWrapper>
          <EmployeeDeleteHead>
            <Spacer 
              width={toRem(24)}
              height={toRem(24)}
            />
            <EmployeeDeleteTitle>
              Вы уверены что хотите <br /> удалить сотрудника?
            </EmployeeDeleteTitle>
            <Button 
              iconPrefix={<CloseIcon />}
              size="s"
              variant="ghost"
              onClick={onDeleteClose}
            />
          </EmployeeDeleteHead>
          <EmployeeDeleteButtons>
            <Button 
              variant="secondary"
              colorScheme="neutral"
              label="Отмена"
              size="l"
              onClick={onDeleteClose}
            />
            <Button 
              label="Удалить"
              size="l"
              onClick={onDeleteConfirm}
            />
          </EmployeeDeleteButtons>
        </EmployeeDeleteWrapper>
      </Modal>
    </>
  )
}